import * as locale from './locale';
import * as ui from './ui';
import * as router from './router';
import * as submission from './submission';

export {
	locale,
	ui,
	router,
	submission,
};



// WEBPACK FOOTER //
// ./src/selectors/index.js